import React, { useEffect, useState } from "react";

const probe = async (bridge) => {
  const ctl = new AbortController();
  const t = setTimeout(() => ctl.abort(), 3000);
  try {
    await fetch(`${new URL(bridge).origin}/api/streams`, { mode: "no-cors", cache: "no-store", signal: ctl.signal });
    return true;
  } catch (e) { return false; } finally { clearTimeout(t); }
};

const LOOK = {
  checking: ["bg-amber-400", "text-amber-200 border-amber-400/40", "Checking Tapo bridge…"],
  online: ["bg-emerald-400", "text-emerald-200 border-emerald-400/40", "Tapo bridge online"],
  offline: ["bg-rose-500", "text-rose-200 border-rose-500/40", "Tapo bridge offline · run NexusEye.bat on this PC"],
};

export const EyeBridgeBadge = ({ bridge, streaming }) => {
  const [st, setSt] = useState("checking");
  const [at, setAt] = useState(null);
  useEffect(() => {
    let alive = true;
    const run = async () => { const ok = await probe(bridge); if (alive) { setSt(ok ? "online" : "offline"); setAt(new Date()); } };
    run();
    const id = setInterval(run, 5000);
    return () => { alive = false; clearInterval(id); };
  }, [bridge]);
  const [dot, cls, label] = LOOK[st];
  return (
    <div className={`flex items-center gap-2 rounded-full border px-4 py-1.5 text-xs font-bold bg-white/5 ${cls}`} data-testid="eye-bridge-badge" data-status={st}>
      <span className="relative flex w-2.5 h-2.5">
        {st === "online" && <span className={`absolute inset-0 rounded-full ${dot} animate-ping opacity-60`} />}
        <span className={`relative w-2.5 h-2.5 rounded-full ${dot}`} />
      </span>
      <span data-testid="eye-bridge-badge-label">{label}{st === "online" && streaming ? " · streaming to Nexus" : ""}</span>
      {at && <span className="nx-mono text-[10px] opacity-60" data-testid="eye-bridge-badge-time">{at.toLocaleTimeString("en-US", { timeZone: "America/Chicago" })}</span>}
    </div>
  );
};
